module.exports = __webpack_public_path__ + "static/media/artist_04.467808f0.png";